import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { OrderService } from '../order.service';
import { IOrder } from '@redirector-service/shared';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class OrderResolver implements Resolve<IOrder|null> {
  private orderService = inject(OrderService);
  private logger = inject(NGXLogger);
  private router = inject(Router);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IOrder|null> {
    const orderId = route.paramMap.get('orderId');
    if (!orderId) {
      this.logger.error('Order ID not found in route parameters');
      return new Observable<IOrder>(subscriber => {
        subscriber.error('Order ID not found');
      });
    } else {
      return this.orderService.getOrder(orderId).pipe(
        catchError(error => {
          this.logger.error('Error fetching order', error);
          this.router.navigate(
            ['/beyond-the-brew'], 
            // { queryParams: { message: 'Error fetching order' } }
          );
          return of(null);
        })
      );
    }
  }
}
